var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavbarOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#154165",
    d: "m6.764 1.14-.22.22a.375.375 0 0 0 0 .531L12.12 7.47H.375A.375.375 0 0 0 0 7.844v.313c0 .207.168.375.375.375h11.746L6.544 14.11a.375.375 0 0 0 0 .53l.22.22a.375.375 0 0 0 .53 0l6.596-6.594a.375.375 0 0 0 0-.53L7.295 1.14a.375.375 0 0 0-.53 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarOpen);
export default __webpack_public_path__ + "static/media/navbar_open.c393258e693b85ff5fdf0a424343ebb0.svg";
export { ForwardRef as ReactComponent };